/**
 * Centralized theme configuration.
 *
 * All design-token imports, the CSS variables import, and the ThemeProvider
 * theme name are derived from this single file.  When the theme changes (or
 * the path format changes, as happened in the v6 → v7 migration), only this
 * file needs updating.
 */

// Side-effect import: injects CSS custom properties (--one-color-*, --one-spacing-*, …)
import '@one/design-tokens/css/regular/navify/light/variables.css';

import type { PredefinedTheme } from '@one/web-components';

/** Theme name passed to OwcThemeProvider. */
export const APP_THEME: PredefinedTheme = 'regular_navify_light';

/**
 * Design-token object for the active theme.
 *
 * Usage in styled-components:
 *   import { owcTheme } from 'core/theme/theme.config';
 *   border: 1px solid ${owcTheme['one-color-background-intensity-low']};
 */
export { owcTheme } from '@one/design-tokens/js/regular/navify/light';
